/* global angular, moment */
/**
 * Created by lari on 26/04/2017.
 */
(function () {
  'use strict';
  angular.module('vcexam')
    .component('exameditor', {
      restrict: 'E',
      bindings: {
        exam: '='
      },
      templateUrl: 'vcexam/exameditor-component.tpl.html',
      controllerAs: 'vm',
      controller: ['$log', 'vertxEventBusService', '$window', 'ExamHelper', 'Rlog', 'PrintHelper', '$http',
        function ($log, vertxEventBusService, $window, ExamHelper, Rlog, PrintHelper, $http) {
          let vm = this;
          vm.save = save;
          vm.addBiopsyField = addBiopsyField;
          vm.printBiopsyLabels = printBiopsyLabels;
          vm.finishExam = ExamHelper.finishExam;
          vm.clearDoctor = clearDoctor;
          vm.saveDoctor = saveDoctor;
          vm.previewUrl = PrintHelper.examPreviewUrl(vm.exam._id, vm.exam.consultid);
          vm.addTrackerValue = addTrackerValue;

          function save() {
            $log.debug('exameditor save called');
            vm.exam.$save();
          }

          function addBiopsyField() {
            let biopsy = {
              label: '',
              avalues: [],
              values: []
            };
            vm.exam.template.biopsy.biopsies.push(biopsy);
            $log.debug('Biospies: ', vm.exam.template.biopsy.biopsies);
          }

          function printBiopsyLabels() {
            // cancel all pending $saves, $save again, on return send label print request
            if (vm.exam.$hasPendingActions()) {
              $log.debug('open exam has pending actions!');
              Rlog.debug('examination', 'exameditor', 'exam has pending actions!',
                {
                  examid: vm.exam._id, examtype: vm.exam.template.type,
                  patientid: vm.exam.patientid
                });
              vm.exam.$cancel();
              vm.exam.$save().$then(function () {
                reallyPrint();
              });
            }
            else {
              reallyPrint();
            }
          }

          // /routes/fop/exam/false/false/58f8820cb148b776e918dd0e/58f88208b148b776e918dd0d
          function reallyPrint() {
            $http({
              url: `/routes/fop/examlabels/true/true/${vm.exam._id}`,
              method: 'GET'
            }).success(function () {
              vm.labelsprinted = true;
            }).error(function () {
              vm.labelsprinted = false;
            });
          }

          function saveDoctor(doctor) {
            vm.exam.template.biopsy.pathology = doctor;
            vm.save();
          }


          function clearDoctor() {
            delete vm.exam.template.biopsy.pathology;
            /*            if (vm.newref && vm.newref.doctor) {
                          delete vm.newref.doctor;
                        }*/
          }


          // moved to examhelper
          /* function finishExam() {
            var btest = false;
            var biopsies = [];
            $log.debug('examination-controller.finishExam entered');


            // build diagnosis string from parts for quick reference
            if (angular.isObject(vm.exam.template.diagnosis)) {
              vm.exam.diagnosis = '';
              for (let i = 0; i < vm.exam.template.diagnosis.avalues.length; i++) {
                vm.exam.diagnosis += vm.exam.template.diagnosis.avalues[i].name;
                if (i !== vm.exam.template.diagnosis.avalues.length - 1) {
                  vm.exam.diagnosis += ', ';
                }
              }
            }

            // add formated date vor easy identification and display ordering
            vm.exam.time = moment().format('HH:mm');

            // create biopsy referral for exams with biopsy field

            // test if biopsie entries where actually created
            if (angular.isObject(vm.exam.template.biopsy) && vm.exam.template.biopsy.biopsies.length > 0) {
              biopsies = vm.exam.template.biopsy.biopsies;
              btest = false;
              for (let i = 0; i < biopsies.length; i++) {
                if (biopsies[i].avalues.length > 0) {
                  btest = true;
                }
              }
              if (btest) {
                createReferral();
              }
            }
          } // finishExam*/

          function addTrackerValue(trackervalue) {
            $log.debug('exam editor addTrackervalue called for: ', trackervalue);
            if (angular.isUndefined(vm.exam.template.trackervalues)) {
              vm.exam.template.trackervalues = {};
            }
            // reminder: prefixing 'v' is necessary because numberonly string can not be converted into xml tags
            if (angular.isUndefined(vm.exam.template.trackervalues['v' + trackervalue.trackerid])) {
              vm.exam.template.trackervalues['v' + trackervalue.trackerid] = {name: trackervalue.name, entries: []};
            }
            vm.exam.template.trackervalues['v' + trackervalue.trackerid].entries.push(trackervalue.def);
            vm.save();
          }


          // listen for examination updates
          vertxEventBusService.on('examinations.update', function (message) {
            let messages = message.split(':');
            $log.debug('exam update mesg: ', message);

            // only refresh exam if change was NOT triggered by this browser
            if (messages[1] !== $window.sessionStorage.getItem('sprtabid') && vm.exam._id === messages[0]) {
              vm.exam.$refresh();
              $log.debug('(exameditor) refreshed openexam');
            }
            else {
              $log.debug(' (exameditor) ignored openexam change');
            }
          });

          // listen for examination creates
          // I think this is obsolete at this place, belongs on currentexam list
          /*          vertxEventBusService.on('examinations.create', function (message) {
                      let messages = message.split(':');
                      $log.debug('exam create mesg: ', message);
                      vm.exam.$refresh();
                    });*/


          vm.sprref = `Überweisungen für abgeschlossene Untersuchungen können Sie in der Überweisungsansicht der
                       Konsultation einsehen und editieren. Änderungen an Biospeiefeldern, die Sie nach Abschluß der
                       Untersuchung vornehmen, werden NICHT automatisch in bestehende Überweisungen übernommen.`;

        }] // controller
    }); // component

// klammerfriedhof
}());